import SinglePackageItem from './SinglePackageItem';

// @vue/component
export default {
  name: 'PackageGroup',

  components: {
    SinglePackageItem,
  },

  props: {
    packages: {
      type: Array,
      default: () => [],
    },
    promotionPackages: {
      type: Array,
      default: () => [],
    },
    activePackage: {
      type: Object,
      default: () => {},
    },
  },
};
